import {
  CHANGE_WEBSITE_LOGIN_MODE,
  ChangeWebsiteLoginMode,
  WebsiteLoginModeEnum,
} from './website-login-types'

export function changeWebsiteLoginMode(
  mode: WebsiteLoginModeEnum,
): ChangeWebsiteLoginMode {
  return {
    type: CHANGE_WEBSITE_LOGIN_MODE,
    payload: mode,
  }
}

export type WebsiteLoginActions = ChangeWebsiteLoginMode
